import type { ReactNode } from "react";

export interface MenuFooterProps {
  start?: ReactNode;
  end?: ReactNode;
}

export function MenuFooter({ start, end }: Readonly<MenuFooterProps>) {
  return (
    <div className="flex items-center justify-between gap-2 border-t border-border-subtle px-3 py-2">
      {start}
      {end}
    </div>
  );
}
